export default "__VITE_ASSET__7acd4c0c__"